import React from 'react';

import {job as jobUrl} from '../../../util/urls';
import {Tab} from '../Tab';
import {Tabs} from '../Tabs';

type JobDetailTabsProps = {
  entityName: string;
  projectName: string;
  jobId: string;
  jobVersion?: string;
  jobTab: string;
};

export const JobDetailTabs = ({
  entityName,
  projectName,
  jobId,
  jobVersion,
  jobTab,
}: JobDetailTabsProps) => {
  const hrefValue = (tabValue: string): string => {
    const urlParams = {
      entityName,
      projectName,
      jobId,
      jobVersion,
      jobTab: tabValue,
    };
    return jobUrl(urlParams);
  };

  return (
    <Tabs value={jobTab}>
      <Tab label="Runs" value="runs" href={hrefValue('runs')} />
      <Tab
        label="Job details"
        value="job_details"
        href={hrefValue('job_details')}
      />
      <Tab
        label="Version details"
        value="version_details"
        href={hrefValue('version_details')}
      />
    </Tabs>
  );
};
